import bemowo from '@/assets/js/geometry/bemowo'
import bialoleka from '@/assets/js/geometry/bialoleka'
import bielany from '@/assets/js/geometry/bielany'
import mokotow from '@/assets/js/geometry/mokotow'
import ochota from '@/assets/js/geometry/ochota'
import pragaPolnoc from '@/assets/js/geometry/praga-polnoc'
import pragaPoludnie from '@/assets/js/geometry/praga-poludnie'
import rembertow from '@/assets/js/geometry/rembertow'
import srodmiescie from '@/assets/js/geometry/srodmiescie'
import targowek from '@/assets/js/geometry/targowek'
import ursus from '@/assets/js/geometry/ursus'
import ursynow from '@/assets/js/geometry/ursynow'
import wawer from '@/assets/js/geometry/wawer'
import wesola from '@/assets/js/geometry/wesola'
import wilanow from '@/assets/js/geometry/wilanow'
import wlochy from '@/assets/js/geometry/wlochy'
import wola from '@/assets/js/geometry/wola'
import zoliborz from '@/assets/js/geometry/zoliborz'

export default [
  {
    id: 4,
    name: 'Bemowo',
    coords: bemowo
  },
  {
    id: 1,
    name: 'Białołęka',
    coords: bialoleka
  },
  {
    id: 2,
    name: 'Bielany',
    coords: bielany
  },
  {
    id: 14,
    name: 'Mokotów',
    coords: mokotow
  },
  {
    id: 13,
    name: 'Ochota',
    coords: ochota
  },
  {
    id: 6,
    name: 'Praga-Północ',
    coords: pragaPolnoc
  },
  {
    id: 9,
    name: 'Praga-Południe',
    coords: pragaPoludnie
  },
  {
    id: 10,
    name: 'Rembertów',
    coords: rembertow
  },
  {
    id: 8,
    name: 'Śródmieście',
    coords: srodmiescie
  },
  {
    id: 3,
    name: 'Targówek',
    coords: targowek
  },
  {
    id: 11,
    name: 'Ursus',
    coords: ursus
  },
  {
    id: 17,
    name: 'Ursynów',
    coords: ursynow
  },
  {
    id: 15,
    name: 'Wawer',
    coords: wawer
  },
  {
    id: 16,
    name: 'Wesoła',
    coords: wesola
  },
  {
    id: 18,
    name: 'Wilanów',
    coords: wilanow
  },
  {
    id: 12,
    name: 'Włochy',
    coords: wlochy
  },
  {
    id: 7,
    name: 'Wola',
    coords: wola
  },
  {
    id: 5,
    name: 'Żoliborz',
    coords: zoliborz
  }
]



// WEBPACK FOOTER //
// ./src/assets/js/geometry/index.js